// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2LQq8","text":"styles_text__acAeM","divider":"styles_divider__vsBKR","disabled":"styles_disabled__uG1sH","link":"styles_link__AhRfG"};